"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var trackingParams = function trackingParams() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.APP_STARTED:
      {
        return (0, _extends2.default)({}, action.payload.trackingParams);
      }

    default:
      return state;
  }
};

var _default = trackingParams;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/trackingParams.js
// module id = 643
// module chunks = 209 210 211 212